import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function LockScreen() {
  const { ontgrendel, logout } = useAuth();
  const [bezig, setBezig] = useState(false);
  const [mislukt, setMislukt] = useState(false);

  const probeer = async () => {
    setBezig(true); setMislukt(false);
    const ok = await ontgrendel();
    setBezig(false);
    if (!ok) setMislukt(true);
  };

  useEffect(() => { probeer(); /* eslint-disable-next-line */ }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#0a0e1a', color: '#e2e8f0', padding: 24, textAlign: 'center' }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>{'\u{1F512}'}</div>
      <h1 style={{ fontSize: 20, margin: '0 0 8px', color: '#fff' }}>App vergrendeld</h1>
      <p style={{ color: '#94a3b8', margin: '0 0 28px', maxWidth: 280 }}>Ontgrendel met je vingerafdruk of gezicht om verder te gaan.</p>
      <button onClick={probeer} disabled={bezig} style={{ background: '#00D4AA', color: '#0a0e1a', border: 'none', borderRadius: 12, padding: '14px 28px', fontSize: 16, fontWeight: 700, cursor: 'pointer', minWidth: 240, opacity: bezig ? 0.6 : 1 }}>
        {bezig ? 'Bezig...' : 'Ontgrendel'}
      </button>
      {mislukt && <p style={{ color: '#f87171', marginTop: 16, fontSize: 14 }}>Ontgrendelen geannuleerd of mislukt. Probeer opnieuw.</p>}
      <button onClick={() => { window.__skipBioAuto = true; logout(); }} style={{ background: 'transparent', color: '#94a3b8', border: 'none', marginTop: 24, fontSize: 14, textDecoration: 'underline', cursor: 'pointer' }}>Met wachtwoord inloggen</button>
    </div>
  );
}
